import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { formatDate } from "@/utils/media";

interface NewsCardProps {
  item: NewsItem;
  layout?: "row" | "column";
}

export default function NewsCard({ item, layout = "row" }: NewsCardProps) {
  if (layout === "column") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-colors"
      >
        <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.title}
            title={`${item.title} - 影视资讯`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute top-2 left-2 h-6 px-2 flex items-center rounded bg-accent-500 text-background-50 text-[11px] font-medium">
            {item.category}
          </span>
        </div>
        <div className="p-4">
          <h3 className="font-heading font-bold text-base text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition-colors">
            {item.title}
          </h3>
          <p className="mt-2 text-sm text-foreground-500 line-clamp-2">{item.summary}</p>
          <p className="mt-3 text-xs text-foreground-400 flex items-center gap-1.5">
            <i className="ri-time-line"></i>
            {formatDate(item.date)}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex gap-4 py-4 border-b border-background-200/70 last:border-b-0"
    >
      <div className="w-32 h-20 md:w-44 md:h-28 shrink-0 rounded-lg overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 line-clamp-2 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1.5 text-xs md:text-sm text-foreground-500 line-clamp-2 hidden sm:block">
          {item.summary}
        </p>
        <div className="mt-2 flex items-center gap-3 text-xs text-foreground-400">
          <span className="h-5 px-2 flex items-center rounded bg-secondary-100 text-secondary-800 text-[11px] font-medium">
            {item.category}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {formatDate(item.date)}
          </span>
        </div>
      </div>
    </Link>
  );
}